import React, { FunctionComponent, useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import * as actions from "redux/actions/image-variable.actions";
import DashboardLayout from "components/DashboardLayout/DashboardLayout";
import getImageVariableSelector, {
  getCount,
} from "redux/selectors/image-variable.selector";
import DashboardView from "views/DashboardView/DashboardView";
import i18next from "i18next";
import "./i18n";
import SuccessAlert from "components/SuccessAlert/SuccessAlert";
import { hideSuccessNotification } from "redux/actions/success.actions";
import getSuccessSelector, {
  getSuccessText,
} from "redux/selectors/success.selector";
import { SUCCESS_TEXT } from "common/constants/successMesages.constants";
import { Data } from "components/DashboardTable/types";

const ImageVariableDashboardContainer: FunctionComponent = () => {
  const dispatch = useDispatch();
  const getImageVariablesData = useSelector(getImageVariableSelector());
  const getImageVariablesCount = useSelector(getCount());
  const successSelector = useSelector(getSuccessSelector());
  const successText = useSelector(getSuccessText());
  const [actualPage, setActualPage] = useState(0);
  const [keys, setKeys] = useState<string[]>([]);

  useEffect(() => {
    dispatch(actions.getImageVariables(actualPage));
  }, [dispatch, actualPage]);

  useEffect(() => {
    if (getImageVariablesData.imageVariable.length) {
      const textVariableKeys = Object.keys(
        getImageVariablesData.imageVariable[0]
      );
      setKeys(textVariableKeys);
    }
    return () => {
      setKeys([]);
    };
  }, [getImageVariablesData.imageVariable]);

  setTimeout(() => {
    if (successSelector) {
      dispatch(hideSuccessNotification());
    }
  }, 2500);

  const onDeleteImageVariables = (imageVariablesIds: string[]) => {
    dispatch(actions.onDeleteImageVariables(imageVariablesIds));
  };

  const editImageVariables = (imageVariableId: string) => {
    dispatch(actions.onSelectEditImageVariables(imageVariableId));
  };

  const search = (query: string) => {
    dispatch(actions.getImageVariables(actualPage));
  };

  return (
    <DashboardLayout>
      {successSelector &&
        (successText === SUCCESS_TEXT.edited ? (
          <SuccessAlert message={i18next.t("TEXT_VARIABLE:EDITED")} />
        ) : (
          <SuccessAlert message={i18next.t("TEXT_VARIABLE:DELETED")} />
        ))}
      <DashboardView
        search={search}
        keys={keys}
        data={getImageVariablesData.imageVariable as Data[]}
        title="Image variables"
        onDelete={onDeleteImageVariables}
        onEdit={editImageVariables}
        actualPage={actualPage}
        setPage={setActualPage}
        count={getImageVariablesCount}
      />
    </DashboardLayout>
  );
};
export default ImageVariableDashboardContainer;
